import { render, staticRenderFns } from "./mobHome.vue?vue&type=template&id=1a87162a"
import script from "./mobHome.vue?vue&type=script&lang=js"
export * from "./mobHome.vue?vue&type=script&lang=js"
import style0 from "./mobHome.vue?vue&type=style&index=0&id=1a87162a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports